<template>
  <v-app>
    <!-- Toolbar -->
    <extended-toolbar v-if="$route.name === 'home'"></extended-toolbar>
    <app-toolbar v-else></app-toolbar>

    <!-- Drawer -->
    <app-drawer v-if="$vuetify.breakpoint.xsOnly"></app-drawer>

    <!-- Content -->
    <v-content>
      <router-view />
    </v-content>

    <!-- Footer -->
    <app-footer></app-footer>

    <!-- Overlays -->
    <app-overlays />
  </v-app>
</template>

<style>
.themed-card-title {
  color: #2e2e2e;
  font-size: 1.5rem;
  margin-bottom: 10px;
  margin-top: 1.5rem;
  border-left: 15px solid var(--v-accent-base);
}
</style>

<script>
import AppToolbar from "@/components/layout/Toolbar";
import ExtendedToolbar from "@/components/layout/ExtendedToolbar";
import AppFooter from "@/components/layout/Footer";
import AppOverlays from "@/components/overlays";
import AppDrawer from "@/components/layout/Drawer";

export default {
  components: {
    AppToolbar,
    AppFooter,
    AppOverlays,
    ExtendedToolbar,
    AppDrawer
  },
  watch: {
    "$store.state.user": {
      immediate: true,
      deep: true,
      handler(user) {
        this.setNavigationLinks(user);
      }
    }
  },
  methods: {
    setNavigationLinks(user) {
      let links = [];
      // Links that will always exist
      // Home
      links.push({
        title: "Home",
        to: "/"
      });
      // Terms of use
      links.push({
        title: "Terms of use",
        to: "/terms"
      });
      // If the user is not signed in
      if (!user) {
        // Request access
        links.push({
          title: "Request Access",
          to: "/request-access"
        });
      } else {
        // the user exists
        if ((user.emailVerified && user.accessGranted) || user.admin) {
          // Explore data
          links.push({
            title: "Explore Data",
            to: "/explore"
          });
          // Visualise my data
          links.push({
            title: "My Data",
            to: "/my-data"
          });
        } else {
          // The user doesn't have access yet
          links.push({
            title: "Application Status",
            to: "/application-status"
          });
        }
        // Only for admins
        if (user.admin) {
          links.push({
            title: "Control Panel",
            to: "/control-panel"
          });
        }
      }

      this.$store.state.navigationLinks = links;
    }
  }
};
</script>
